<template>
  <div>
    <!-- <van-overlay :show="pushType" @click="pushType = false" style="background-color:rgba(0,0,0,0.9)">

    </van-overlay> -->
    <van-popup
      v-model="popupdata.popupShop"
      class="cc-popup"
      v-if="popupdata"
      :close-on-click-overlay="false"
    >
      <div class="popup-box" v-if="popupdata.ispoptype === 'activity'">
        <img :src="popupdata.activity[0].picUrls[0]" class="image" />
        <div
          class="popup-btn"
          v-if="popupdata.activity[0].alertEventType === 'take_part_in'"
        >
          <a :href="popupdata.activity[0].alertUrl">立即参与</a>
        </div>
        <div
          class="popup-btn"
          v-if="popupdata.activity[0].alertEventType === 'receive'"
          @click="$router.push({ name: 'unclaimed' })"
        >
          立即领取
        </div>
      </div>
      <van-swipe
        v-if="popupdata.ispoptype === 'system'"
        class="systemPopup"
        :autoplay="3000"
        :duration="500"
        indicator-color="#FF3400"
      >
        <van-swipe-item
          class="image-box"
          v-for="(image, index) in popupdata.system[0].picUrls"
          :key="index"
        >
          <img :src="image" class="image" />
        </van-swipe-item>
      </van-swipe>
      <div class="wrapper" v-if="popupdata.ispoptype === 'upgrade'">
        <h3 class="page-title">恭喜您升级{{ popupdata.tagName }}</h3>
        <div class="logo-box">
          <img :src="popupdata.gradeLogo" alt="" />
        </div>
        <template v-if="hasGot">
          <van-divider
            class="van-divider"
            :style="{
              color: '#e9ab51',
              borderColor: '#e9ab51',
              padding: '0 16px'
            }"
            >立即享用新特权</van-divider
          >
          <div class="icon-list">
            <ul>
              <li
                class="list-item"
                v-for="(popItem, popIndex) in popUpDtoList"
                :key="popIndex"
              >
                <img :src="popItem.catIcon" alt="" />
                <p class="icon-des">{{ popItem.catName }}</p>
              </li>
            </ul>
          </div>

          <van-divider
            class="van-divider"
            :style="{
              color: '#e9ab51',
              borderColor: '#e9ab51',
              padding: '0 16px'
            }"
            >我的升级礼包</van-divider
          >
          <div class="discount">
            <span class="coins-part" v-if="givenIntegralValue"
              >{{ givenIntegralValue }}积分</span
            >
            <span class="coupon-part" v-if="givenCouponValue"
              >{{ givenCouponValue }}元</span
            >
          </div>
          <div class="button-box">
            <van-button
              class="close"
              type="default"
              @click="popupdata.popupShop = false"
              >我知道了</van-button
            >
            <van-button
              class="to-user"
              type="defalut"
              @click="
                $router.push({ name: 'store-home' }),
                  (popupdata.popupShop = false)
              "
              >立即使用</van-button
            >
          </div>
        </template>
        <template v-else>
          <van-divider
            class="van-divider"
            :style="{
              color: '#8b8b8b',
              borderColor: '#8b8b8b',
              padding: '0 16px'
            }"
            >我的新特权</van-divider
          >
          <ul class="receive-before">
            <li>?</li>
            <li>?</li>
            <li>?</li>
          </ul>
          <van-divider
            class="van-divider"
            :style="{
              color: '#8b8b8b',
              borderColor: '#8b8b8b',
              padding: '0 16px'
            }"
            >我的升级包</van-divider
          >
          <div class="giftBox">
            <img src="@/assets/salesManPart/upgradepup3.png" alt="" />
          </div>
          <div class="button-box">
            <button class="get-now" type="defalut" @click="immediatelyReceive">
              立即领取
            </button>
          </div>
        </template>
      </div>

      <img
        v-if="popupdata.ispoptype !== 'upgrade'"
        src="@/assets/popupClose.png"
        class="popupClose"
        @click="popupdata.popupShop = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['channel', 'popUpDtoList'],
  data () {
    return {
      pushType: true,
      popupdata: null,
      hasGot: false
    }
  },
  computed: {},
  methods: {
    // 立即领取
    immediatelyReceive () {
      this.$service
        .doTask({
          taskType: '100400'
        })
        .then(res => {
          this.hasGot = !this.hasGot
          const data = res.data
          this.givenIntegralValue = data.givenIntegralValue || 0
          this.givenCouponValue = data.givenCouponValue || 0
        })
    },
    updataPopUp () {
      const data = this.popupdata
      const params =
        data.ispoptype === 'upgrade'
          ? data.upgrade[0]
          : data.ispoptype === 'activity'
          ? data.activity[0]
          : data.system[0]
      this.$service.savePopUpLog({
        actId: params.id,
        popUpPushType: params.pushType
      })
    }
  },
  created() {
    // this.$service.getPopUp().then(res => {
    //   const data = res.data
    //   if (!data) return false
    //   const popupList = data.popupList
    //   if (popupList && popupList.length) {
    //     let activity = []
    //     let system = []
    //     let upgrade = []
    //     // 优先级   个人中心  升级弹窗  活动弹窗  系统提示弹窗
    //     // 其它地方  活动弹窗  系统提示弹窗 无升级
    //     popupList.map(item => {
    //       // alertEventType 弹窗事件：noevent无事件，receive 领取
    //       // pushType  popup活动弹窗、upgrade等级升级弹窗
    //       const isCurPage = item.alertPushChannel.indexOf(this.channel)
    //       if (isCurPage !== -1 && item.pushType === 'upgrade') {
    //         upgrade.push(item)
    //       } else {
    //         if (isCurPage !== -1 && item.alertEventType === 'noevent') {
    //           system.push(item)
    //         } else if (isCurPage !== -1 && item.alertEventType !== 'noevent') {
    //           activity.push(item)
    //         }
    //       }
    //     })

    //     this.popupdata = {
    //       activity: activity,
    //       system: system,
    //       upgrade: upgrade,
    //       ispoptype:
    //       upgrade.length !== 0 ? 'upgrade'
    //         : activity.length !== 0 ? 'activity'
    //           : system.length !== 0 ? 'system'
    //             : 'none',
    //       popupShop: !!(activity.length !== 0 || system.length !== 0 || upgrade.length !== 0),
    //       tagName: data.tagName,
    //       gradeLogo: data.tagCode ? require(`@/assets/salesManPart/grade/${data.tagCode}.png`) : ''
    //     }
    //     if (this.popupdata.popupShop) this.updataPopUp()
    //   }
    // })
  }
}
</script>

<style lang="stylus" scoped>
.cc-popup
  padding-bottom 45px
>>>.van-popup
  background none
.systemPopup,
.image-box
  border-radius 5px
  overflow hidden
  width 300px!important
  // height 350px!important
.image-box .image
  width 300px
  max-height 400px
  // height 350px
.popupClose
  width 35px
  height 35px
  position absolute
  bottom 0
  left 135px
  z-index 99999
.popup-box
  position relative
  width 320px
.popup-box img
  width 320px
  height auto
.popup-box .popup-btn
  position absolute
  bottom 20px
  left 87px
  width 146px
  height 30px
  line-height 30px
  background-color #FC4C00
  border-radius 30px
.popup-box .popup-btn,
.popup-box .popup-btn a
  text-align center
  color white
  font-size 14px
  display block
  // 升级相关
.wrapper
  text-align center
  padding-top 30px
  width 100vw
  // height ceil( 100vh - 30px )
.page-title
  font-size 20px
  font-family PingFangSC-Medium,PingFang SC
  font-weight 500
  color rgba(233,171,81,1)
  line-height 28px
.logo-box
  text-align cneter
  width 177px
  height 177px
  margin 0 auto
  position relative
.logo-box img
  width 247px
  height 247px
  position absolute
  left -35px
  top -35px
.van-divider
  margin 0
.icon-list
  width 320px
  margin 0 auto
  overflow-x scroll
.icon-list ul
  padding 15px 0
  display flex
.list-item
  flex 1
  text-align center
  padding 0 10px
.list-item img
  width 60px
  height 60px
.list-item .icon-des
  font-size 12px
  font-family PingFangSC-Medium,PingFang SC
  font-weight 500
  color rgba(233,171,81,1)
  line-height 17px
.discount
  color #fff
  width 100%
  padding 25px 0 10px
  overflow hidden
.discount span
  width 124px
  height 52px
  line-height 52px
  text-align center
  display inline-block
  border-radius 4px 4px
.discount .coins-part
  font-size 18px
  color #6a430a
  background url('~@/assets/salesManPart/upgradepup5.png') no-repeat
  background-size contain
  margin-right 25px
.discount .coupon-part
  font-size 18px
  color #8b1717
  background url('~@/assets/salesManPart/upgradepup6.png') no-repeat
  background-size contain
.button-box
  margin-top 10px
.button-box .close
 width 114px
 height 33px
 border-radius 17px
 background none
 color rgba(233,171,81,1)
 font-size 14px
 border 1px solid rgba(233,171,81,1)
 line-height 33px
 margin-right 25px
.button-box .to-user
  width 114px
  height 33px
  background none
  background rgba(233,171,81,1)
  border-radius 17px
  line-height 33px
  color #fff
  border 0 none
.button-box .get-now
  width 146px
  height 33px
  background rgba(233,171,81,1)
  border-radius 17px
  line-height 33px
  color #fff
  font-size 14px
  border 0 none
.receive-before
  padding 15px 0
.receive-before li
  width 48px
  height 48px
  background rgba(119, 119, 119, 0.28)
  border-radius 100%
  border dashed 1px #777777
  font-size 18px
  color #8B8B8B
  text-align center
  line-height 48px
  display inline-block
  margin 0 22px
.giftBox
  height 100px
  width 120px
  margin 0 auto
  padding-top 30px
.giftBox img
 width 100%
 height 100%
</style>
